import { Icon }      from "@chakra-ui/react";
import { IconProps } from "@chakra-ui/react";

const StandIcon = (props: IconProps) => {
    return (
        <Icon {...props}>
            <svg viewBox="0 0 512 512">
                <g fill="currentColor">
                    <path d="M465.73,183.452l-80.411-96.499-3.623-4.342h-252.5l-3.623,4.342-80.411,96.499-2.663,3.356v4.368c.041,24.29,16.78,45.364,40.432,50.9v186.312h345.616v-186.445c23.428-5.706,39.926-26.68,39.952-50.793v-4.368l-2.77-3.33h0ZM327.814,94.678l48.236,96.499c0,22.205-18.001,40.205-40.205,40.205s-40.205-18.001-40.205-40.205l-15.981-96.499h48.156,0ZM183.079,94.678h48.236l-15.981,96.499c0,22.205-18.001,40.205-40.205,40.205s-40.205-18.001-40.205-40.205l48.156-96.499h0ZM404.416,327.813H106.983l-.08.027v-85.898c10.937-2.665,20.725-8.783,27.914-17.446,18.368,22.205,51.258,25.315,73.463,6.948,2.529-2.093,4.856-4.419,6.948-6.948,18.39,22.205,51.3,25.297,73.505,6.906,2.513-2.081,4.825-4.393,6.906-6.906,18.368,22.205,51.258,25.315,73.463,6.948,2.529-2.093,4.856-4.419,6.948-6.948,7.29,8.785,17.251,14.948,28.366,17.553v85.765h0Z"/>
                </g>
            </svg>
        </Icon>
    )
}

export default StandIcon;